// extracted by mini-css-extract-plugin
module.exports = {"connect":"OfficeCurrentNumbers_connect_1RYQk"};